var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-timeline-item"},[_c('div',{staticClass:"m-timeline-item__time"},[(_vm.icon)?_c('m-icon',{attrs:{"name":_vm.icon,"color":_vm.color}}):_c('span',{style:(_vm.color ? 'color:' + _vm.color : '')},[_vm._v(" "+_vm._s(_vm.text))])],1),_c('div',{staticClass:"m-timeline-item__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }